

class AccordionItemHTMLElement extends HTMLElement {
    static observedAttributes = ['open'];

    constructor() {
        super();
        this.toggler = this.querySelector( 'button' );
        this.content = this.toggler?.nextElementSibling;
    }

    connectedCallback() {
        this.toggler?.addEventListener( 'click', this.toggle.bind( this ) );
        this.setStates();
    }

    disconnectedCallback() {
    }

    toggle() {
        this.toggleAttribute( 'open' );
        const siblings = this.closest( 'accordion-group' )?.querySelectorAll( 'accordion-item' );
        siblings?.forEach( sibling => {
            if ( sibling !== this ) sibling.removeAttribute( 'open' );
        } );
    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback( name, oldVal, newVal ) {
        switch ( name ) {
            case 'open':
                this.setStates();
                break;
        }
    }

    setStates() {
        if ( this.getAttribute( 'open' ) === '' ) {
            this.toggler?.setAttribute( 'aria-expanded', 'true' );
        } else {
            this.toggler?.setAttribute( 'aria-expanded', 'false' );
        }
    }
}

customElements.define( 'accordion-item', AccordionItemHTMLElement );